// eslint-disable-next-line no-unused-vars
import React, { memo, useState, useEffect } from 'react';
import { node } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { PUBLIC_ROUTES } from 'Constants';
import LoginModal from 'Components/Login/LoginModal';
import AuthHOC from 'Containers/Auth/Auth';
import useRouter from 'Hooks/useRouter';
import useUser from 'Hooks/useUser';
import isPublicPage from 'Utils/isPublicPage';

const LoginModalWrapper = memo(({ children }) => {
  const { data: user } = useUser();
  const { t } = useTranslation();
  const { location } = useRouter();
  const [open, setOpen] = useState(false);
  const isPagePublic = isPublicPage(location.pathname, PUBLIC_ROUTES);

  useEffect(() => {
    if (user.email && !isPagePublic) {
      setOpen(!user.loggedIn);
    }
  }, [isPagePublic, user.email, user.loggedIn]);

  return (
    <>
      <AuthHOC>
        <LoginModal
          size="xs"
          open={ open }
          canDisplayPartnership={ false }
          title={ t('common.sessionExpired') }
          message={ t('common.sessionExpiredLoginPromptMessage') }
        />
      </AuthHOC>
      { children }
    </>
  );
});

LoginModalWrapper.propTypes = {
  children: node
};

LoginModalWrapper.displayName = 'LoginModalWrapper';

export default LoginModalWrapper;
